// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'widget';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M6.853 1H1.711A.711.711 0 0 0 1 1.711v5.142a.71.71 0 0 0 .711.711h5.142a.711.711 0 0 0 .711-.71V1.71a.711.711 0 0 0-.71-.71zm9.436 0h-5.142a.711.711 0 0 0-.711.711v5.142a.71.71 0 0 0 .71.711h5.143a.711.711 0 0 0 .711-.71V1.71a.711.711 0 0 0-.71-.71zm-9.436 9.435H1.711a.711.711 0 0 0-.711.712v5.142c0 .392.318.71.711.71h5.142a.711.711 0 0 0 .711-.71v-5.142a.711.711 0 0 0-.71-.712zm6.865.821v4.923m2.461-2.46h-4.923'
  />
);

export const viewBox = '0 0 18 18';
